import {SET_TYPES} from "../types"
import {SetTypesAction, TypesType} from "../interface"

export default function setTypes(types: TypesType): SetTypesAction {
  return {
    type: SET_TYPES,
    types: types,
  }
}
